/**
 * Typography tokens
 *
 * @module @smoothie-framework/ui-core/tokens
 */
export const TYPOGRAPHY_FONT_FAMILY_KEYS = ['body', 'heading', 'mono'];
export const TYPOGRAPHY_FONT_SIZE_KEYS = [
    '2xs',
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    '2xl',
    '3xl',
    '4xl',
    '5xl',
    '6xl',
    '7xl',
    '8xl',
    '9xl',
];
export const TYPOGRAPHY_LINE_HEIGHT_KEYS = [
    'shorter',
    'short',
    'moderate',
    'tall',
    'taller',
];
export const TYPOGRAPHY_FONT_WEIGHT_KEYS = [
    'thin',
    'light',
    'normal',
    'medium',
    'semibold',
    'bold',
    'extrabold',
];
export const TYPOGRAPHY_LETTER_SPACING_KEYS = [
    'tighter',
    'tight',
    'normal',
    'wide',
    'wider',
    'widest',
];
export const TYPOGRAPHY_TEXT_STYLE_SCALE = {
    '2xs': { lineHeight: 'shorter', letterSpacing: 'normal' },
    xs: { lineHeight: 'short', letterSpacing: 'normal' },
    sm: { lineHeight: 'short', letterSpacing: 'normal' },
    md: { lineHeight: 'moderate', letterSpacing: 'normal' },
    lg: { lineHeight: 'moderate', letterSpacing: 'normal' },
    xl: { lineHeight: 'moderate', letterSpacing: 'normal' },
    '2xl': { lineHeight: 'short', letterSpacing: 'normal' },
    '3xl': { lineHeight: 'shorter', letterSpacing: 'normal' },
    '4xl': { lineHeight: 'shorter', letterSpacing: 'tight' },
    '5xl': { lineHeight: 'shorter', letterSpacing: 'tight' },
    '6xl': { lineHeight: 'shorter', letterSpacing: 'tight' },
    '7xl': { lineHeight: 'shorter', letterSpacing: 'tight' },
    '8xl': { lineHeight: 'shorter', letterSpacing: 'tight' },
    '9xl': { lineHeight: 'shorter', letterSpacing: 'tight' },
};
const defaultSansStack = '"Inter Variable", sans-serif';
export const typography = {
    fontFamily: {
        body: defaultSansStack,
        heading: defaultSansStack,
        mono: '"JetBrains Mono Variable", monospace',
    },
    fontSize: {
        '2xs': 0.625,
        xs: 0.75,
        sm: 0.875,
        md: 1,
        lg: 1.125,
        xl: 1.25,
        '2xl': 1.5,
        '3xl': 1.875,
        '4xl': 2.25,
        '5xl': 3,
        '6xl': 3.75,
        '7xl': 4.5,
        '8xl': 6,
        '9xl': 8,
    },
    lineHeight: {
        shorter: 1.25,
        short: 1.375,
        moderate: 1.5,
        tall: 1.625,
        taller: 2,
    },
    fontWeight: {
        thin: 100,
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        extrabold: 800,
    },
    letterSpacing: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0em',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em',
    },
};
//# sourceMappingURL=typography.js.map